import { forwardRef, type SVGProps } from 'react';

export type PlayProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const Play = forwardRef<SVGSVGElement, PlayProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path
      d="M11 8.87v14.26L22.13 16zm0-3.56a2 2 0 00-2-.07A2 2 0 008 7v18a2 2 0 001 1.73 2 2 0 002-.07l14.1-9a2 2 0 000-3.32z"
      fillRule="evenodd"
    />
  </svg>
));
Play.displayName = 'Play';
